import t_05_2255_b from './KZ.T.05.2255 black.svg'
import t_05_2255 from './KZ.T.05.2255.svg'

// import t_05_0294 from './t_05_0294.png'

export default [
  t_05_2255,
  t_05_2255_b
]
